import React from 'react';

// Mappatura delle icone disponibili
const iconMap: Record<string, string> = {
  // Rimpiazzi formali (SVG) per vecchie emoji
  '🛡️': 'admin',
  '🏠': 'search_home',
  '🏢': 'landlord',
  '👥': 'tenant',
  '⭐': 'starfull',
  '🔍': 'search_anim',
  '👤': 'user',
  '📝': 'docs',
  '✍️': 'docs',
  '📬': 'docs',
  '💰': 'payment',
  '📊': 'dashboard',
  '⚡': 'alert',
  '🚨': 'alert',
  '�': 'audit',
  '💳': 'payment',
  '⚙️': 'settings',
  '📅': 'docs',
  '💡': 'docs',
  '🚪': 'logout',
  // Nuovi nomi per icone specifiche
  'admin': 'admin',
  'landlord': 'landlord',
  'agency': 'agency',
  'tenant': 'tenant',
  'user': 'user',
  'search': 'search_anim',
  'home': 'search_home',
  'star': 'starfull',
  'star-full': 'starfull',
  'star-half': 'starhalf',
  'star-hollow': 'starhollow',
  'hamburger': 'hamburger',
  'docs': 'docs',
  'payment': 'payment',
  'dashboard': 'dashboard',
  'logout': 'logout',
  'alert': 'alert',
  'settings': 'settings',
  'review': 'review',
  'search_home': 'search_home',
  'starfull': 'starfull',
  // Fallback testuali minimali, niente emoji nei contesti formali
  'credit-card': 'payment',
  'file-text': 'docs',
  'plus': 'docs',
  'arrow-left': 'docs',
  'check': 'docs',
  'x': 'docs',
  'trash': 'docs',
  'edit': 'docs',
  'download': 'docs',
  'upload': 'docs',
  'calendar': 'docs',
  'clock': 'docs',
  'mail': 'docs',
  'phone': 'docs',
  'map': 'docs',
  'camera': 'docs',
  'wrench': 'docs',
  'tool': 'docs',
  'hammer': 'docs',
  'alert-triangle': 'alert',
  'info': 'dashboard',
  'lock': 'settings',
  'key': 'settings'
};

interface IconProps {
  name: string;
  size?: number;
  className?: string;
  style?: React.CSSProperties;
}

const Icon: React.FC<IconProps> = ({ name, size = 24, className = '', style = {} }) => {
  const iconName = iconMap[name];

  // Se non c'è una mappatura, renderizza il nome come testo (fallback)
  if (!iconName) {
    return (
      <span
        className={className}
        style={{ fontSize: size, ...style }}
      >
        
      </span>
    );
  }

  // Renderizza l'SVG come immagine
  return (
    <img
      src={`/icons/${iconName}.svg`}
      alt={name}
      className={className}
      style={{
        width: size,
        height: size,
        ...style
      }}
      onError={(e) => {
        // Fallback all'emoji se l'immagine non carica
        const target = e.target as HTMLImageElement;
        target.style.display = 'none';
        const fallback = document.createElement('span');
        fallback.textContent = name;
        fallback.style.fontSize = `${size}px`;
        fallback.className = className;
        Object.assign(fallback.style, style);
        target.parentNode?.replaceChild(fallback, target);
      }}
    />
  );
};

export default Icon;